import { createFeatureSelector, createSelector } from '@ngrx/store';
import { itemConfigurationInputRequestFeatureKey, ItemConfigurationInputRequestState, itemConfigurationInputResponseFeatureKey, ItemConfigurationInputResponseState } from './item-configuration-input.reducer';
import { ItemConfigurationInputResponse } from 'src/app/models/pricing-view-models';

export const selectItemConfigurationInputRequestState = 
  createFeatureSelector<ItemConfigurationInputRequestState>(itemConfigurationInputRequestFeatureKey);
export const selectItemConfigurationInputResponseState =
    createFeatureSelector<ItemConfigurationInputResponseState>(itemConfigurationInputResponseFeatureKey);


export const selectItemConfigurationInputRequest = createSelector(
    selectItemConfigurationInputRequestState,
    (state: ItemConfigurationInputRequestState) => {
        let rtn = {} as ItemConfigurationInputRequestState;
        rtn.itemConfigurationInputRequest = state.itemConfigurationInputRequest;
        return rtn;
    }
);

export const selectItemConfigurationInputResponse = createSelector(
  selectItemConfigurationInputResponseState,
  (state: ItemConfigurationInputResponseState) => {
    //console.log('selectItemConfigurationInputResponse', state);

    let rtn = {} as ItemConfigurationInputResponse;
    rtn.ProjectScheduleLineItem = state.itemConfigurationInputResponse.ProjectScheduleLineItem;
    rtn.ProjectScheduleLineItemPricing = state.itemConfigurationInputResponse.ProjectScheduleLineItemPricing;
    rtn.CodeStringGroups = state.itemConfigurationInputResponse.CodeStringGroups;
    rtn.ProductModelValues = state.itemConfigurationInputResponse.ProductModelValues;
    rtn.CategoryName = state.itemConfigurationInputResponse.CategoryName;
    rtn.ProductModel = state.itemConfigurationInputResponse.ProductModel;
    rtn.ProductModelClass = state.itemConfigurationInputResponse.ProductModelClass;
    rtn.ProductTypeCategory = state.itemConfigurationInputResponse.ProductTypeCategory;
    rtn.ProductType = state.itemConfigurationInputResponse.ProductType;
    return rtn;
  },
  
);